import { render, staticRenderFns } from "./AppDrawerAbout.vue?vue&type=template&id=2da66fdd"
import script from "./AppDrawerAbout.vue?vue&type=script&lang=js"
export * from "./AppDrawerAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports